import {Course} from '@app/modules/learning-apps/models/course.model';
import {ChipThemeColor} from '@progress/kendo-angular-buttons';

export class LearningApp {
  public courses: Course[];
  public learningAppImage: string;
  public learningAppName: string;
  public productivityIntegration: boolean;
  public productivityIntegrationStatus: string;
  public productivityIntegrationTheme: ChipThemeColor;
  public subjectImage: string;
  public subjectName: string;
  public subjectOrder: number;
  public timeIntegration: boolean;
  public timeIntegrationStatus: string;
  public timeIntegrationTheme: ChipThemeColor;

  constructor() {
    this.courses                       = [];
    this.learningAppImage              = null;
    this.productivityIntegration       = false;
    this.timeIntegration               = false;
    this.learningAppName               = '';
    this.subjectName                   = '';
    this.subjectImage                  = '';
    this.subjectOrder                  = 0;
    this.productivityIntegrationStatus = null;
    this.productivityIntegrationTheme  = null;
    this.timeIntegrationStatus         = null;
    this.timeIntegrationTheme          = null;
  }
}
